import OrderForwardEditRequest from "../../../api/raily/order-forward/edit/order-forward-edit.request";
import OrderForwardEditParams from "./order-forward-edit-params";

const create = (params: OrderForwardEditParams): OrderForwardEditRequest => {
  return {
    contractId: params.contractId,
    forwardingId: params.forwardingId,
  };
};

const orderForwardEditParamsFactory = {
  create,
};

export default orderForwardEditParamsFactory;
